import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useScoring, isRedZone } from '../lib/scoring';
import {
  LargeTitle, ListGroup, ListRow, Monogram, ScorePill, SearchField, Segmented, PageSkeleton, EmptyRow,
} from '../components/ui';

export default function Clinicians() {
  const { profile } = useAuth();
  const { threshold, weights } = useScoring();
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('name');
  const [clinicians, setClinicians] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!profile?.id) return;
    api.clinicians.list()
      .then(setClinicians)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [profile?.id]);

  if (loading) return <PageSkeleton hero={false} rows={8} />;

  const shown = clinicians
    .filter((c) => c.full_name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => (sort === 'name'
      ? a.full_name.localeCompare(b.full_name)
      : (a.avg_cscore ?? Infinity) - (b.avg_cscore ?? Infinity)));

  return (
    <div>
      <LargeTitle title="Clinicians" subtitle={`${clinicians.length} clinicians`} />
      <div className="lg:flex lg:items-start lg:gap-3">
        <div className="lg:flex-1"><SearchField value={search} onChange={setSearch} placeholder="Search clinicians" /></div>
        <div className="mb-4 lg:w-[340px]">
          <Segmented
            value={sort}
            onChange={setSort}
            options={[{ value: 'name', label: 'A to Z' }, { value: 'score', label: 'Lowest score first' }]}
          />
        </div>
      </div>
      <ListGroup>
        {shown.length === 0 && <EmptyRow>No clinicians found</EmptyRow>}
        {shown.map((c) => (
          <ListRow
            key={c.id}
            to={`/clinicians/${c.id}`}
            leading={<Monogram name={c.full_name} score={c.avg_cscore} src={c.image_url} />}
            title={c.full_name}
            subtitle={c.kipu_clinician_id ? `Clinician ID ${c.kipu_clinician_id}` : 'No KIPU ID'}
            trailing={(
              <ScorePill
                score={c.avg_cscore}
                flagged={isRedZone(c.avg_cscore, threshold)}
                breakdown={c.breakdown}
                weights={weights}
                title={`${c.full_name} average`}
              />
            )}
          />
        ))}
      </ListGroup>
    </div>
  );
}
